<template>
    <div>
        {{ description }}
        <span v-if="params.data.payment_gateway in paymentGatewayImages">
            <span v-if="params.data.payment_gateway == 'IRIDIUM'"><b> - Iridium Corporation</b></span>
            <img
                v-else
                :class="['gateway-image', params.data.payment_gateway]"
                :src="getImageUrl()"
                :height="getImageHeight()"
                alt="gateway"
                border="0"
            />
        </span>
        <span v-if="paymentMethod == 3">
            <span class="ml-1" v-if="status == 1">
                <b-button
                    class="paypal-button"
                    variant="primary"
                    size="xs"
                    href="javascript:void(0)"
                    v-if="!this.params.data.paypal_open"
                    @click="paypalAcceptVoid"
                    >Accept</b-button
                >
                <b-button
                    class="paypal-button"
                    variant="primary"
                    size="xs"
                    href="javascript:void(0)"
                    v-if="!this.params.data.paypal_open"
                    @click="paypalAcceptVoid"
                    >Void</b-button
                >
                <b-button
                    class="paypal-button"
                    variant="primary"
                    size="xs"
                    href="javascript:void(0)"
                    v-if="this.params.data.paypal_open"
                    @click="paypalRefresh"
                    >Refresh</b-button
                >
            </span>
            <span v-if="status == 2">
                (Invoice Sent)
            </span>
            <span v-if="status == 3">
                (Under Review)
                <b-button 
                    class="ml-1 paypal-button" 
                    variant="primary" 
                    size="xs" 
                    href="javascript:void(0)" 
                    @click="paypalRefresh"
                    >Refresh</b-button
                >
            </span>
        </span>
    </div>
</template>

<script>
    import isNil from 'lodash/isNil';
    import { mapGetters } from 'vuex';
    import { escapeHTML } from '../../../utils/strings';

    export default {
        computed: {
            ...mapGetters('header', ['userPayPalWebsite']),
        },
        beforeMount() {
            this.description =
                this.params.data.description.includes('eCheck / ACH Direct Debit')
                    ? this.params.data.description
                    : escapeHTML(this.params.data.description);
            this.status = this.params.data.status;
            this.paymentMethod = this.params.data.payment_method;
        },
        data() {
            return {
                description: null,
                status: null,
                paymentGatewayImages: {
                    AUTHORIZE_NET: { value: '/static/images/gateways/authorize-net.png', height: 17 },
                    QUANTUM: { value: '/static/images/gateways/quantum-logo.png', height: 17 },
                    BEANSTREAM: { value: '/static/images/gateways/bambora-logo.png', height: 18 },
                    PAYPAL: { value: '/static/images/gateways/paypal-logo.png', height: 19 },
                    PAYLEAP: { value: '/static/images/gateways/payleap-logo.png', height: 25 },
                    STRIPE: { value: '/static/images/gateways/stripe.png', height: 19 },
                },
            };
        },
        methods: {
            isNil,
            paypalAcceptVoid() {
                this.params.data.paypal_open = true;
                window.open(this.userPayPalWebsite);
            },
            paypalRefresh() {
                this.params.refresh(this.params.data.id);
            },
            getImageUrl() {
                return this.paymentGatewayImages[this.params.data.payment_gateway].value;
            },
            getImageHeight() {
                return this.paymentGatewayImages[this.params.data.payment_gateway].height;
            },
        },
    };
</script>

<style lang="scss" scoped>
    :deep(.paypal-button) {
        padding: 0.4rem 0.4rem !important;
        margin-bottom: 0.3rem;
    }

    .gateway-image {
        margin-left: 0.2rem;
        padding-bottom: 0.2rem;
        &.QUANTUM {
            padding-bottom: 0;
        }
        &.BEANSTREAM, &.AUTHORIZE_NET {
            padding-bottom: 0.3rem;
        }
    }
</style>
